import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './country-link.scss.js';

class CountryLink extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
    }
    render() {
        return $ `<div class="country-link ${this.rtl || isRTL() ? 'rtl' : ''}"><slot></slot></div>`;
    }
}
CountryLink.styles = css_248z;
__decorate([
    e({ type: Boolean })
], CountryLink.prototype, "rtl", void 0);
customElements.define('country-link', CountryLink);

export { CountryLink };
